import { TaxReceiptType } from '@/entities/user'

export const TaxReceiptTypeMap = {
  [TaxReceiptType.CASH_RECEIPT_PERSONAL]: '현금영수증',
  [TaxReceiptType.CASH_RECEIPT_BUSINESS]: '현금영수증',
  [TaxReceiptType.TAX_INVOICE]: '전자세금계산서',
}
